module.exports = __webpack_public_path__ + "static/media/graduation.b874f8e1.jpg";